"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Modal_1 = __importDefault(require("../elements/Modal"));
var react_1 = __importDefault(require("react"));
var react_calendly_1 = require("react-calendly");
var react_gtm_module_1 = __importDefault(require("react-gtm-module"));
var react_redux_1 = require("react-redux");
var calendlyEventHandler = function (_a) {
    var data = _a.data;
    react_gtm_module_1.default.dataLayer({ dataLayer: { event: data.event } });
};
var Calendly = function (_a) {
    var url = _a.url, utm = _a.utm, showModal = _a.showModal, closeModal = _a.closeModal, pageSettings = _a.pageSettings;
    var utmRedux = react_redux_1.useSelector(function (s) { return s; });
    return (react_1.default.createElement(Modal_1.default, { showModal: showModal, closeModal: closeModal },
        react_1.default.createElement(react_calendly_1.CalendlyEventListener, { onDateAndTimeSelected: calendlyEventHandler, onEventScheduled: calendlyEventHandler, onEventTypeViewed: calendlyEventHandler, onProfilePageViewed: calendlyEventHandler },
            react_1.default.createElement(react_calendly_1.InlineWidget, { pageSettings: pageSettings, url: url, styles: {
                    height: '100%'
                }, utm: utm || utmRedux || null }))));
};
exports.default = Calendly;
//# sourceMappingURL=Calendly.js.map